import { memo } from 'react';
export const RequiredMark = memo(() => {
    return <span className="text-pink mr-1">*</span>;
});
